import { jsx } from "react/jsx-runtime";
import { useStore } from "@nanostores/react";
import { createContext, useContext, useEffect, useState } from "react";
import { EnokiFlow } from "./EnokiFlow.js";
const EnokiFlowContext = createContext(null);
function EnokiFlowProvider({ children, ...config }) {
  const [enokiFlow] = useState(() => new EnokiFlow(config));
  return /* @__PURE__ */ jsx(EnokiFlowContext.Provider, { value: enokiFlow, children });
}
function useEnokiFlow() {
  const context = useContext(EnokiFlowContext);
  if (!context) {
    throw new Error("Missing `EnokiFlowContext` provider");
  }
  return context;
}
function useZkLogin() {
  const flow = useEnokiFlow();
  return useStore(flow.$zkLoginState);
}
function useZkLoginSession() {
  const flow = useEnokiFlow();
  return useStore(flow.$zkLoginSession).value;
}
function useAuthCallback() {
  const flow = useEnokiFlow();
  const [state, setState] = useState(null);
  const [handled, setHandled] = useState(false);
  const [hash, setHash] = useState(null);
  useEffect(() => {
    const listener = () => setHash(window.location.hash.slice(1).trim());
    listener();
    window.addEventListener("hashchange", listener);
    return () => window.removeEventListener("hashchange", listener);
  }, []);
  useEffect(() => {
    if (!hash) return;
    (async () => {
      try {
        setState(await flow.handleAuthCallback(hash));
        window.location.hash = "";
      } finally {
        setHandled(true);
      }
    })();
  }, [hash, flow]);
  return { handled, state };
}
export {
  EnokiFlowProvider,
  useAuthCallback,
  useEnokiFlow,
  useZkLogin,
  useZkLoginSession
};
//# sourceMappingURL=react.js.map
